import DashboardIcon from '@mui/icons-material/Dashboard';
import { SvgIconProps } from '@mui/material/SvgIcon';
import React from 'react';

const HomeIcon = (props: SvgIconProps) => <DashboardIcon {...props} />;
export default HomeIcon;
